import { connect } from 'react-redux';

import { 
  _closeAddExcept, _saveSelfExcept, _deleteSelfExcept,
  _updateSelfExceptHour, _updateSelfExceptMinute
} from '@/actions/mainAction';

import AddExcept from '@/components/main/AddExcept';

export default connect(
  state => ({
    isOpen: state.main.isOpenAddExceptModal,
    hour: state.main.selfExceptTimeInfo.hour,
    minute: state.main.selfExceptTimeInfo.minute,
  }),
  {
    _closeAddExcept, _saveSelfExcept, _deleteSelfExcept,
    _updateSelfExceptHour, _updateSelfExceptMinute
  }
)(AddExcept);


// WEBPACK FOOTER //
// ./src/containers/main/AddExceptContainer.js